import { Cornerstone } from '@rpi/api';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useInitCheckout = () => {
  const {
    data: response,
    isLoading: initLoading,
    error: initError,
  } = useQuery<AxiosResponse<Cornerstone.CheckoutSummary>, Error>({
    queryKey: ['init-checkout'],
    queryFn: () => Cornerstone.checkoutPreview({}),
  });

  return {
    checkoutData: response?.data,
    initLoading,
    initError,
  };
};
